import { atom } from 'recoil'
import { Point } from 'types/building'

type Props = {
  selectedFloor?: number
  selectedPoint?: string
  selectedImage?: number
  isSelectPoint?: boolean
  isOpenLeftMenu: boolean
  isOpenMiniMap: boolean
  selectedArea?: string
  pointDetail?: Point
  imageIsLoading?: boolean
  isClickToDirection?: boolean
  isSelectPointInLeftMenu?: boolean
  isClickToNextFloor?: boolean
  isClickFromTourCarousel?: boolean
  baseH?: number
}

const currentViewerState = atom<Props>({
  key: 'currentViewer',
  default: {
    selectedFloor: undefined,
    selectedPoint: undefined,
    selectedImage: undefined,
    selectedArea: undefined,
    isOpenLeftMenu: true,
    isOpenMiniMap: false,
    pointDetail: undefined,
    imageIsLoading: false,
    isClickToDirection: false,
    isSelectPointInLeftMenu: false,
    isSelectPoint: false,
    isClickToNextFloor: false,
    isClickFromTourCarousel: false
  }
})

export default currentViewerState
